var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.52344,
    cy: 8.10742,
    r: 8,
    fill: "#ADADAD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19014 11.4418C5.02742 11.279 5.02742 11.0152 5.19014 10.8525L11.2675 4.7751C11.4303 4.61238 11.6941 4.61238 11.8568 4.7751C12.0195 4.93781 12.0195 5.20163 11.8568 5.36435L5.77939 11.4418C5.61667 11.6045 5.35285 11.6045 5.19014 11.4418Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8567 11.4418C12.0195 11.279 12.0195 11.0152 11.8567 10.8525L5.77933 4.7751C5.61661 4.61238 5.35279 4.61238 5.19007 4.7751C5.02735 4.93781 5.02735 5.20163 5.19007 5.36435L11.2675 11.4418C11.4302 11.6045 11.694 11.6045 11.8567 11.4418Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDelete);
export default __webpack_public_path__ + "static/media/icon_delete.64b5dde2df02bf7035bce697d913b10c.svg";
export { ForwardRef as ReactComponent };